export const URL_PARAMETERS = {
  // sort
  column: 'column',
  direction: 'direction',

  // pagination
  currentPage: 'currentPage',
  perPage: 'perPage',

  // misc
  showColumns: 'showColumns',
};
